<nb-card [ngClass]="customNbCardClass">
    <nb-card-header>
        <div class="back-and-title">
            <a
              nbButton
              ghost
              status="primary"
              (click)="close()"
            >
              <i class="fas fa-circle-chevron-left fa-xl"></i>
            </a>
            <div class="title" [innerHTML]="title | translate"></div>
        </div>
    </nb-card-header>
    <!-- LIST -->
    <nb-card-body class="elements-list-body">
        <nb-accordion multiple>
            <!-- LINKED INVESTMENTS -->
            <nb-accordion-item expanded="true" disabled="true" class="linked-elements mt-4">
                <nb-accordion-item-header class="investment">
                    <span >
                        {{ "Linked investments" | translate }}
                    </span>
                </nb-accordion-item-header>
                <nb-accordion-item-body [nbSpinner]="allElementsLoading()">
                    <div class="form-group">
                        @if (!allElementsLoading()) {
                            @for (elt of linkedElements(); track elt.id) {
                                <ng-container *ngTemplateOutlet="element; context: { elt, selectable: false }"></ng-container>
                            } @empty {
                                <!-- NO DATA -->
                                <div class="no-data text-center">
                                    <span>{{ "No investment" | translate }}</span>
                                </div>
                            }
                        }
                    </div>
                </nb-accordion-item-body>
            </nb-accordion-item>
            <!-- SELECTABLE INVESTMENTS -->
            <nb-accordion-item expanded="true" disabled="true" class="not-linked-elements">
                <nb-accordion-item-header>
                    <span>
                        {{ "Add an investment" | translate }}
                    </span>
                </nb-accordion-item-header>
                <nb-accordion-item-body [nbSpinner]="allElementsLoading()">
                    @if (!allElementsLoading()) {
                        <div class="form-group">
                            <input
                                nbInput
                                type="text"
                                placeholder="{{ 'Research' | translate }}"
                                [ngModel]="searchValue()"
                                (ngModelChange)="search($event)"
                                class="research-input"
                            >
                            @for (elt of notLinkedElementsAfterFilter(); track elt.id) {
                                <ng-container *ngTemplateOutlet="element; context: { elt, selectable: true }"></ng-container>
                            } @empty {
                                <!-- NO DATA -->
                                <div class="no-data text-center">
                                    <span>{{ "No investment" | translate }}</span>
                                </div>
                            }
                        </div>
                    }
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion>
    </nb-card-body>

    <!-- ADD BUTTON -->
    @if (selectedIds()?.length) {
        <nb-card-footer class="investment">
            <button nbButton (click)="linkElements()">
                {{ "Add the investments" | translate }}
            </button>
        </nb-card-footer>
    }
</nb-card>

<!-- ELEMENT WITH OR WITHOUT CHECKBOX -->
<ng-template #element let-elt="elt" let-selectable="selectable">
    <div class="form-field list-element">
        @if (selectable) {
            <!-- CHECKBOX -->
            <nb-checkbox
                id="{{ elt.id }}"
                [checked]="selectedIds().includes(elt.id)"
                class="mx-4 w-100"
                [class.warning]="!isInPeriod(elt)"
                (checkedChange)="onCheckboxChange(elt.id, $event); notLinkedElementChecked(elt);"
            >
                <ng-container *ngTemplateOutlet="elementContent; context: { elt }"></ng-container>
            </nb-checkbox>
        } @else {
            <div class="d-flex">
                <button nbButton ghost (click)="removeLinkedElement(elt.id)" class="remove-button">
                    <i class="fal fa-square-minus fa-xl"></i>
                </button>
                <ng-container *ngTemplateOutlet="elementContent; context: { elt }"></ng-container>
            </div>
        }
    </div>
</ng-template>

<!-- INVESTMENT CONTENT -->
<ng-template #elementContent let-elt="elt">
    <div class="element-content">
        <!-- LABEL -->
        <b>{{ elt.label }}</b>
        <!-- PRICE -->
        <span>
            {{ elt.current_price | ngxCurrency:currency }} {{ "in" | translate }} 
            <span [class.red]="!isInPeriod(elt)">{{ elt.final_schedule_to }}</span>
        </span>
        <!-- STATUS -->
        <span>{{ "Status" | translate }}: {{ elt.status_object?.name }} </span>
        <!-- IMPACT -->
        @if (elt?.impact_roadmap_indicators?.length) {
            <span>
                {{ "Impact" | translate }}: 
                {{ getRoadmapIndicatorsString(elt) | slice: 0:55 }}
                @if (getRoadmapIndicatorsString(elt).length > 55) {
                    ...
                }
            </span>
        }
    </div>
</ng-template>